import { TablePagination } from '@mui/material'
import React from 'react'

type PaginationPropsType = {
  setPage: (value: number) => void
  setOpenId: (value: number) => void
  setRowsPerPage: (value: number) => void
  page: number
  rowsPerPage: number
  count: number
}
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}
const Pagination = ({ setPage, setOpenId, setRowsPerPage, page, rowsPerPage, count }: PaginationPropsType) => {
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage)
    setOpenId(-1)
    scrollToTop()
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
    scrollToTop()
  }
  return (
    <TablePagination
      rowsPerPageOptions={[5, 10, 25]}
      component="div"
      className="paginator"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
    />
  )
}

export default Pagination
